import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import AuthLayout from '@/components/auth-layout';
import AuthCard from '@/components/auth-card';
import LoginForm from './login-form';
import ForgotPasswordForm from './forgot-password-form';

const BackendSignIn = () => {
  const [showForgotPassword, setShowForgotPassword] = useState<boolean>(false);

  return (
    <AuthLayout>
      <AuthCard onBack={showForgotPassword ? () => setShowForgotPassword(false) : undefined}>
        <AnimatePresence mode="wait">
          {showForgotPassword ? (
            <motion.div
              key="forgot"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.2 }}
            >
              <ForgotPasswordForm />
            </motion.div>
          ) : (
            <motion.div
              key="login"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.2 }}
            >
              <LoginForm onForgotPassword={() => setShowForgotPassword(true)} />
            </motion.div>
          )}
        </AnimatePresence>
      </AuthCard>
    </AuthLayout>
  );
}

export default BackendSignIn;